import { Component, inject, OnDestroy } from '@angular/core';
import { ComponentUrl } from 'services/navigation.service';
import { AbsenceComponent } from 'components/users/absence.component';
import { UserService } from 'services/user.service';
import { DashboardService } from 'services/dashboard.service';
import { DashboardElementModel } from 'models/generated/Identity.Api.Models.DashboardElement';
import { DashboardType } from 'enums/DashboardType';
import { Layout } from 'modules/layout';
import { Pipes } from 'modules/pipes';
import { FormattedContentDirective } from 'directives/formatted-content.directive';
import { PushService } from 'services/push.service';
import { Subscription } from 'rxjs';
import { MessageType } from 'enums/MessageType';
import { UserDashboardElementSettingModel } from 'models/generated/Identity.Api.Models.User';

@ComponentUrl('')
@Component({
	templateUrl: './dashboard.component.html',
	imports: [Layout, AbsenceComponent, FormattedContentDirective, Pipes]
})
export class DashboardComponent implements OnDestroy {
	private readonly userService = inject(UserService);
	private readonly dashboardService = inject(DashboardService);
	private readonly pushService = inject(PushService);

	dashboardElements: DashboardElementModel[] = [];
	dashboardType = DashboardType;
	private dashboardChangeSubscription: Subscription;

	constructor() {
		this.loadDashboardElements();
		this.dashboardChangeSubscription = this.pushService.onChanges<{ userId: string }>(MessageType.DashboardChanges).subscribe(message => {
			if (message.data?.userId == this.userService.getCurrentUser().id)
				this.loadDashboardElements();
		});
	}

	async loadDashboardElements() {
		const user = this.userService.getCurrentUser();
		this.dashboardElements = (await this.dashboardService.getDashboardElements())
			.filter(element => element.teamDashboardElements.some(teamElement => user.userTeams.map(ut => ut.teamId).includes(teamElement.teamId)) &&
				!user.settings?.dashboardElementSettings.filter(e => e.isExcluded).map(e => e.dashboardElementId).includes(element.id));
		let maxSortOrder = user.settings?.dashboardElementSettings.reduce((max, element) => Math.max(max, element.sortOrder ?? 0), 0) ?? 0;
		this.dashboardElements.forEach(element => {
			element.settings = user.settings?.dashboardElementSettings.find(metadata => metadata.dashboardElementId == element.id) ?? new UserDashboardElementSettingModel();
			element.settings.sortOrder = element.settings.sortOrder ?? ++maxSortOrder;
		});
		this.dashboardElements.sort((a, b) => (a.settings?.sortOrder ?? 0) - (b.settings?.sortOrder ?? 0));
	}

	ngOnDestroy() {
		this.dashboardChangeSubscription.unsubscribe();
	}
}
